module.exports = __webpack_public_path__ + "static/media/shield-check.1d87f280.svg";